import util from '../lib/util';
import * as DateUtil from '../lib/dateutils';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
import {ValidationError} from "../lib/errors";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
class EntityTimestamp extends Base implements EntityType {
    entityTimestampId: uuid;
    service: string;
    entity: string;
    ts: Date;
    ids: string[];
    constructor(doc: typeof EntityTimestamp | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            entityTimestampId: genUUID(),
            service: null,
            entity: null,
            ts: null,
            ids: [],
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "entityTimestamp";
        // @ts-ignore
        this.entityTimestampId = doc._entityTimestampId || doc.entityTimestampId || doc.entitytimestampid || genUUID();
        // @ts-ignore
        this.service = doc._service || doc.service || null;
        // @ts-ignore
        this.entity = doc._entity || doc.entity || null;
        // @ts-ignore
        this.ts = DateUtil.timestampOnly(doc._ts) || DateUtil.timestampOnly(doc.ts) || null;
        // @ts-ignore
        this.ids = doc._ids || doc.ids || [];
    }
    get id(): uuid { return this.entityTimestampId; }
    addId(id: string): string {
        if (!id) throw new ValidationError('No nulls allowed in an array!');
        if (!this.ids) this.ids = [];
        this.ids.push(id);
        return id;
    }
    updateId(id: string) {
        if (!this.ids) this.ids = [];
        const index = this.ids.findIndex(item => item === id);
        if (index !== -1) { this.ids[index] = id; }
        else this.addId(id);
    }
    removeId(id: string) {
        if (!this.ids) return;
        let foundItems = this.ids?.filter(item => item === id);
        if (foundItems && foundItems.length > 0) {
            this.ids = this.ids.filter(item => !(item === id));
        }
    }
    abandonIds() { this.ids = []; }
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique ID for entityTimestamp"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","comment":"Associated firm"}]; }
    toLowerCase() { return this.entityTimestampId; }
    static override getNonRefArrayFields(): string[] { return ["ids"]; }
    static override getDefaultEntries(): EntityTimestamp[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'entityTimestamp',
    dataArea: 'Firm Settings',
    table: 'ENTITY_TIMESTAMP',
    comment: `Records the most recent update timestamp for an entity type within an external service (Payrix, Twilio, Nylas). Written by the server when a webhook arrives; broadcast to clients via Socket.IO so react-query can invalidate and refetch stale data from that service without storing a local copy of the service's data.`,
    fields: {
        entityTimestampId: {
            type: 'uuid',
            required: true,
            pk: true,
            default: '__UUID__',
            comment: 'Unique ID for entityTimestamp'
        },
        service: {
            type: 'string', required: true, comment: 'Service name'
        },
        entity: {
            type: 'string', required: true, comment: 'Entity name'
        },
        ts: {
            type: 'timestamp', required: true, comment: 'Timestamp'
        },
        ids: {
            type: 'string[]', required: true, comment: 'Entity IDs'
        }
    }
});
    }
}
export default EntityTimestamp;
